import PropTypes from 'prop-types';
import styled from 'styled-components';
import React from 'react';
import * as styles from './tabs.css';

const StyledDiv = styled.div`
  font-weight: ${p => p.boltTitle && 900};
`;

const TabMenu = ({ tabMenuKey, text, active, select, boltTitle }) => {
  const handleSelect = () => select(tabMenuKey);

  return (
    <StyledDiv
      data-test-id='tab-menu'
      className={`${styles.tabMenu} ${active ? styles.active : ''}`}
      onClick={handleSelect}
      boltTitle={boltTitle}
    >
      {text}
    </StyledDiv>
  );
};
TabMenu.propTypes = {
  tabMenuKey: PropTypes.string,
  text: PropTypes.string,
  active: PropTypes.bool,
  select: PropTypes.func,
  boltTitle: PropTypes.bool,
};

export default TabMenu;
